var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXpPath(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.6,
    height: 18,
    viewBox: "0 0 21.6 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8229",
    transform: "translate(-114 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 32733",
    d: "M40.682 3.3a1.132 1.132 0 0 0-1.54-.032l-5.3 4.77a1.118 1.118 0 0 1-1.551-.064 1.056 1.056 0 0 1 .064-1.516l5.3-4.77a3.364 3.364 0 0 1 4.58.094 3.184 3.184 0 0 1 .065 4.51l-6.817 7.054a.622.622 0 0 0-.034.828.678.678 0 0 0 .971.04l7.64-7.859a3.111 3.111 0 0 1 4.41-.055 2.984 2.984 0 0 1 .22 4.082l-3.047 3.572a1.04 1.04 0 0 0 .069 1.426 1.1 1.1 0 0 0 1.413.1l.683-.5a1.12 1.12 0 0 1 1.537.215 1.063 1.063 0 0 1-.22 1.5l-.683.5a3.332 3.332 0 0 1-4.285-.3 3.155 3.155 0 0 1-.2-4.32L47 9.005a.906.906 0 0 0-.055-1.218.988.988 0 0 0-1.324.044l-7.609 7.862a2.882 2.882 0 0 1-4.277-.178 2.731 2.731 0 0 1 .153-3.643L40.7 4.819a1.072 1.072 0 0 0-.018-1.519z",
    transform: "translate(83.502 7.164)",
    style: {
      fill: "#58d39f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2917",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(130.6 21)",
    style: {
      fill: "#58d39f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2920",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(114 11.9)",
    style: {
      fill: "#58d39f"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpPath);
export default __webpack_public_path__ + "static/media/xpPath.701e9bb76108a8e830c9b5731710a145.svg";
export { ForwardRef as ReactComponent };